export default __webpack_public_path__ + "static/media/earth-spinner.0629df33.gif";